/**
 * Unregisters the service worker.
 *
 * NOTE: Use a datadog query to confirm sw.js 404s are disappearing,
 * or have entirely disappeared ideally, before removal.
 * @see https://app.datadoghq.com/apm/traces?query=env%3Aprod%20service%3Aleaflink-web%20operation_name%3Adjango.request%20resource_name%3A%22GET%20404%22%20%40http.path_group%3A%22%2Fsw.js%22&cols=core_service%2Ccore_resource_name%2Clog_duration%2Clog_http.method%2Clog_http.status_code&historicalData=true&messageDisplay=inline&sort=desc&spanType=all&start=1661346680600&end=1662556280600&paused=false
 * @see https://leaflink.slack.com/archives/CDXDCR0RX/p1662556322043449?thread_ts=1658779154.632009&cid=CDXDCR0RX
 */
export default function unregisterServiceWorker() {
  if (window.navigator && navigator.serviceWorker) {
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
      for (const registration of registrations) {
        registration.unregister();
        window.Sentry?.captureMessage('Service Worker unregistered');
      }
    });
  }
}
